import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../auth/services/auth.service';
import { APP_NAV_ITEMS } from '../nav.config';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  private readonly authService = inject(AuthService);

  readonly currentRole = computed(() => this.authService.role() ?? 'partner');
  readonly logoutInProgress = this.authService.logoutInProgress;

  readonly navItems = computed(() =>
    APP_NAV_ITEMS.filter((item) => item.roles.includes(this.currentRole())),
  );

  logout(): void {
    this.authService.logout().subscribe();
  }
}